import { safeJson } from "@/lib/http";
import { supabase } from "@/lib/supabase";

const BASE = process.env.REACT_APP_BACKEND_URL;

async function call(path, method = "GET", body) {
    const { data } = await supabase.auth.getSession();
    const token = data.session?.access_token;
    if (!token) throw new Error("Session expirée, reconnectez-vous.");
    const r = await fetch(`${BASE}${path}`, { method, headers: { Authorization: `Bearer ${token}`, ...(body ? { "Content-Type": "application/json" } : {}) }, body: body ? JSON.stringify(body) : undefined });
    const j = await safeJson(r);
    if (!r.ok) throw new Error(typeof j.detail === "string" ? j.detail : `Erreur ${r.status}`);
    return j;
}

export const startArreteJob = (id, payload) => call(`/api/ia/dossiers/${id}/arrete-plan/jobs`, "POST", payload || {});
export const fetchArreteJob = (id, jobId) => call(`/api/ia/dossiers/${id}/arrete-plan/jobs/${jobId}`);
export const fetchLastArrete = (id) => call(`/api/ia/dossiers/${id}/arrete-plan`);

export async function downloadArretePdf(id, sessionId) {
    const { data } = await supabase.auth.getSession();
    const token = data.session?.access_token;
    if (!token) throw new Error("Session expirée, reconnectez-vous.");
    const q = sessionId ? `?session_id=${encodeURIComponent(sessionId)}` : "";
    const r = await fetch(`${BASE}/api/ia/dossiers/${id}/arrete-plan/pdf${q}`, { headers: { Authorization: `Bearer ${token}` } });
    if (!r.ok) { const j = await safeJson(r); throw new Error(typeof j.detail === "string" ? j.detail : `Erreur ${r.status}`); }
    const blob = await r.blob();
    const name = (r.headers.get("Content-Disposition") || "").match(/filename="([^"]+)"/)?.[1] || "Arrete_Plan.pdf";
    const url = URL.createObjectURL(blob);
    const a = Object.assign(document.createElement("a"), { href: url, download: name });
    a.click();
    URL.revokeObjectURL(url);
}
